import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Box,
  Button,
  Avatar,
  TextField,
} from "@mui/material";
import WifiIcon from "@mui/icons-material/Wifi";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { postJsonData } from "../network/ApiController";
import ApiEndpoints from "../network/ApiEndPoints";
import BbpsParameters from "./BbpsParameters";

const BbpsView2 = () => {
  const [categories, setCategories] = useState([]);
  const [operators, setOperators] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [parameters, setParameters] = useState([]);
  const [selectedOperator, setSelectedOperator] = useState(null);
  const [selectedOperatorName, setSelectedOperatorName] = useState("");
  const [search, setSearch] = useState("");
  const filteredOperators = operators.filter((op) =>
    op.name.toLowerCase().includes(search.toLowerCase()),
  );
  const getCategories = () => {
    postJsonData(
      ApiEndpoints.BBPS2_GET_OPERATORS,
      {},
      setLoading,
      (res) => {
        const data = res?.data?.data || [];
        setCategories(data);
      },
      (err) => console.log(err),
    );
  };

  const getOperatorsByCategory = (categoryId) => {
    setSelectedCategory(categoryId);
    setSearch(""); // 👈 add this

    postJsonData(
      ApiEndpoints.BBPS2_GET_OPERATORS_BYCATEGORY,
      { category: categoryId },
      setLoading,
      (res) => {
        const data = res?.data?.data || [];
        setOperators(data);
      },
      (err) => console.log(err),
    );
  };
  const getParameters = (operatorId, operatorName) => {
    setSelectedOperator(operatorId);
    setSelectedOperatorName(operatorName);

    postJsonData(
      ApiEndpoints.BBPS2_GET_PARAMETERS,
      {
        operator_id: operatorId,
      },
      setLoading,
      (res) => {
        const data = res?.data?.data || [];
        setParameters(data);
        console.log("Parameters:", data);
      },
      (err) => console.log(err),
    );
  };
  useEffect(() => {
    getCategories();
  }, []);
  const filteredCategories = categories.filter((cat) =>
    cat.operator_category_name.toLowerCase().includes(search.toLowerCase()),
  );
  const cardStyle = {
    cursor: "pointer",
    borderRadius: 2,
    textAlign: "center",
    padding: 1,
    height: "95px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "0.2s",
    "&:hover": {
      boxShadow: 4,
      transform: "translateY(-3px)",
    },
  };

  return (
    <Box sx={{ p: 3 }}>
      {selectedCategory && !selectedOperator && (
        <Button
          startIcon={<ArrowBackIcon />}
          size="small"
          variant="contained"
          onClick={() => {
            setSelectedCategory(null);
            setOperators([]);
            setSearch(""); // 👈 reset
          }}
        >
          Back
        </Button>
      )}

      <Typography variant="h6" fontWeight="600" sx={{ mb: 2 }}>
        BBPS Services
      </Typography>
      {!selectedOperator && (
        <Box sx={{ mb: 2, maxWidth: 300 }}>
          <TextField
            fullWidth
            size="small"
            placeholder="Search operator..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Box>
      )}

      {loading && (
        <Box sx={{ textAlign: "center", mb: 2 }}>
          <CircularProgress size={25} />
        </Box>
      )}

      {!selectedOperator && (
        <>
          <Grid container spacing={4}>
            {!selectedCategory &&
              filteredCategories.map((item) => (
                <Grid
                  item
                  key={item.operator_category_id}
                  sx={{ flex: "0 0 20%", maxWidth: "20%" }}
                >
                  <Card
                    sx={cardStyle}
                    onClick={() =>
                      getOperatorsByCategory(item.operator_category_id)
                    }
                  >
                    <CardContent sx={{ p: 1.9 }}>
                      <Avatar
                        sx={{
                          bgcolor: "#5c6bc0",
                          width: 32,
                          height: 32,
                          margin: "auto",
                          mb: 1,
                        }}
                      >
                        <WifiIcon sx={{ fontSize: 18 }} />
                      </Avatar>

                      <Typography variant="body2" fontWeight="500">
                        {item.operator_category_name}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}

            {selectedCategory &&
              filteredOperators.map((item) => (
                <Grid item xs={6} sm={4} md={3} lg={2} key={item.operator_id}>
                  <Card
                    sx={cardStyle}
                    onClick={() => getParameters(item.operator_id, item.name)}
                  >
                    <CardContent sx={{ p: 1.5 }}>
                      <Typography variant="body2">{item.name}</Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
          </Grid>
        </>
      )}

      {selectedOperator && parameters.length > 0 && (
        <BbpsParameters
          operator={selectedOperator}
          parameters={parameters}
          operatorName={selectedOperatorName}
          onBack={() => {
            setSelectedOperator(null);
            setParameters([]);
          }}
        />
      )}
    </Box>
  );
};

export default BbpsView2;
